module.exports = __webpack_public_path__ + "img/499-3f7d76.png";